import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ children, rolesAllowed = [] }) => {
const token = localStorage.getItem("token") || null;
const role = localStorage.getItem("role") || null;

  // 🔐 Not logged in
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // 🔐 Role check
  if (rolesAllowed.length > 0 && !rolesAllowed.includes(role)) {
    return <Navigate to="/products" replace />;
  }

  // ✅ Render allowed content
  return children || <Outlet />;
};

export default ProtectedRoute;